const prodBaseUrl = "https://ref.geoengineers.com";
const stagingBaseUrl = "https://ref-staging.geoengineers.com";
const isProd = window.location.href.indexOf(prodBaseUrl) > -1;
const isStaging = window.location.href.indexOf(stagingBaseUrl) > -1;
const isDev = isProd || isStaging > -1 ? false : true;
// const isDev = false;

let config = {};
let API_HOST = "";
if(isDev){
	API_HOST = "http://localhost:8080";
}else if(isStaging){
	API_HOST = stagingBaseUrl;
}else if(isProd){
	API_HOST = prodBaseUrl;
}

const CONFIG = {
	debug : isDev,
	disableYellowBox : true,
	reduxLoggerEnabled : false,	
    API_HOST : API_HOST,
};

export default CONFIG;